import React from "react";
import { Link } from "react-router-dom";
import { X, Trash2, Plus, Minus } from "lucide-react";
import { useCart } from "../context/CartContext";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "./ui/sheet";
import { Button } from "./ui/button";

const CartDrawer = () => {
  const { items, drawerOpen, setDrawerOpen, updateQty, removeItem, subtotal, shipping, total } = useCart();

  return (
    <Sheet open={drawerOpen} onOpenChange={setDrawerOpen}>
      <SheetContent className="w-full sm:max-w-md flex flex-col p-0">
        <SheetHeader className="px-5 py-4 border-b border-gray-200">
          <SheetTitle className="font-display text-xl text-[#0a0a0a]">
            Your Cart ({items.length})
          </SheetTitle>
        </SheetHeader>

        {items.length === 0 ? (
          <div className="flex-1 flex flex-col items-center justify-center text-center px-6">
            <div className="h-16 w-16 rounded-full bg-gray-100 flex items-center justify-center mb-4">
              <X className="h-8 w-8 text-gray-400" />
            </div>
            <p className="text-gray-600 mb-4">Your cart is empty.</p>
            <Button className="btn-primary" onClick={() => setDrawerOpen(false)} asChild>
              <Link to="/shop">Start Shopping</Link>
            </Button>
          </div>
        ) : (
          <>
            <div className="flex-1 overflow-y-auto px-5 py-3 space-y-4">
              {items.map((i) => (
                <div key={i.key} className="flex gap-3 border-b border-gray-100 pb-4">
                  <img src={i.image} alt={i.name} className="h-20 w-20 object-contain p-1 bg-white rounded border border-gray-200" />
                  <div className="flex-1">
                    <div className="flex justify-between gap-2">
                      <div>
                        <h4 className="font-semibold text-sm text-[#0a0a0a]">{i.name}</h4>
                        <p className="text-xs text-gray-500">{i.size}</p>
                      </div>
                      <button onClick={() => removeItem(i.key)} className="text-gray-400 hover:text-[#b91c1c]">
                        <Trash2 className="h-4 w-4" />
                      </button>
                    </div>
                    <div className="flex items-center justify-between mt-2">
                      <div className="inline-flex items-center border border-gray-300 rounded">
                        <button className="px-2 py-1 hover:bg-gray-100" onClick={() => updateQty(i.key, i.qty - 1)}>
                          <Minus className="h-3 w-3" />
                        </button>
                        <span className="px-3 text-sm font-semibold">{i.qty}</span>
                        <button className="px-2 py-1 hover:bg-gray-100" onClick={() => updateQty(i.key, i.qty + 1)}>
                          <Plus className="h-3 w-3" />
                        </button>
                      </div>
                      <div className="font-semibold text-[#0a0a0a]">${(i.price * i.qty).toFixed(2)}</div>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div className="border-t border-gray-200 px-5 py-4 space-y-2 bg-gray-50">
              <div className="flex justify-between text-sm"><span>Subtotal</span><span className="font-semibold">${subtotal.toFixed(2)}</span></div>
              <div className="flex justify-between text-sm"><span>Shipping</span><span className="font-semibold">{shipping === 0 ? "FREE" : `$${shipping.toFixed(2)}`}</span></div>
              <div className="flex justify-between text-base font-bold pt-2 border-t border-gray-200"><span>Total</span><span className="text-[#b91c1c]">${total.toFixed(2)}</span></div>
              <div className="grid grid-cols-2 gap-2 pt-3">
                <Button variant="outline" onClick={() => setDrawerOpen(false)} asChild>
                  <Link to="/cart">View Cart</Link>
                </Button>
                <Button className="btn-red" onClick={() => setDrawerOpen(false)} asChild>
                  <Link to="/checkout">Checkout</Link>
                </Button>
              </div>
            </div>
          </>
        )}
      </SheetContent>
    </Sheet>
  );
};

export default CartDrawer;
